exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".submit-claim-modal .modal-content{margin:200px auto 0 auto !important}.submit-claim-modal .modal-content .modal-body{padding:25px 20px;text-align:center}.submit-claim-modal .modal-content .modal-body p{font-size:16px;margin-bottom:15px}.submit-claim-modal .modal-content .modal-body p:last-of-type{margin-bottom:0}.submit-claim-modal .modal-content .modal-footer{display:-ms-flexbox;display:flex;-ms-flex:1 1;flex:1 1;-ms-flex-pack:justify;justify-content:space-between;padding:10px}.submit-claim-modal .modal-content .modal-footer .btn{-ms-flex:1 1;flex:1 1;margin:0 5px}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/sass-loader/dist/cjs.js!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/containers/embeddable/utils/SubmitClaimModal.scss
// module id = 735
// module chunks = 1